const hashQuery = (hash) => {
  if (!hash || !hash.includes("?")) {
    return "";
  }
  const parts = hash.split("?");
  parts.shift();
  return parts.join("&");
};

export const readProcessInitParams = (href) => {
  const url = new URL(href, "https://placeholder.local");
  const merged = new URLSearchParams(url.search);
  const fromHash = new URLSearchParams(hashQuery(url.hash));
  fromHash.forEach((value, key) => {
    merged.set(key, value);
  });
  return merged;
};

export const toQueryString = (params) => {
  const serialized = params.toString();
  return serialized ? `?${serialized}` : "";
};
